import { ApiRequestError } from '@/lib/api';
import { GENERIC_FAILURE_MESSAGE } from '@/lib/validation-messages';

/**
 * Props for an inline error.
 *
 * @since 1.0.0
 */
export interface InlineErrorProps {
    error: unknown;
}

/**
 * Shows why a request was refused: the worker's wording with its reference code for an API
 * failure, and a fixed line with reference 1E for anything else.
 *
 * @since 1.0.0
 * @param props - the error to describe, or null when there is none
 * @returns the error element, or null when there is nothing to report
 */
export function InlineError({ error }: InlineErrorProps) {
    if (error === null || error === undefined) {
        return null;
    }

    if (error instanceof ApiRequestError) {
        return (
            <div className="fkwd-form-error" role="alert">
                {error.message}
                <div className="fkwd-form-error__meta">
                    {error.requestId === '' ? error.code : `${error.code} · ${error.requestId}`}
                </div>
            </div>
        );
    }

    return (
        <div className="fkwd-form-error" role="alert">
            {GENERIC_FAILURE_MESSAGE}
        </div>
    );
}
